module.exports = __webpack_public_path__ + "static/collage-2-87573f97219aae960a2d30ece0b8fcf3.jpg";